// src/components/directory/SubmissionModal.js
import ListingForm from './ListingForm';

const SubmissionModal = ({ show, handleClose }) => {
    // ...handleBackdropClick fonksiyonu aynı...
    const handleBackdropClick = (e) => {
        if (e.target.id === "submissionModal") {
            handleClose();
        }
    };
    
    return (
        <div 
            className={`modal fade ${show ? 'show' : ''}`} 
            id="submissionModal" 
            tabIndex="-1" 
            style={{ display: show ? 'block' : 'none', backgroundColor: 'rgba(0,0,0,0.5)' }}
            onClick={handleBackdropClick}
        >
            {/* Modal boyutu "modal-lg" olarak güncellendi */}
            <div className="modal-dialog modal-dialog-centered modal-lg"> 
                <div className="modal-content" style={{ borderRadius: '15px' }}>
                    <div className="modal-header border-0">
                        <h4 className="modal-title fw-light">Join Our Directory</h4>
                        <button type="button" className="btn-close" onClick={handleClose}></button>
                    </div>
                    <div className="modal-body px-4 pb-4">
                       <p className="text-muted mb-4">Add your details to connect with creators. Fields with <span className="text-danger">*</span> are required.</p>
                       <ListingForm onFormSubmit={handleClose} />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default SubmissionModal;